import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M5 17h14v2H5zm7-12L5.33 15h13.34z" />, 'Eject');
